import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

const ERROR_DISPLAY_DURATION = 4000;

/**
 * @param {HTMLButtonElement} button
 * @param {string} message
 */
function showError(button, message) {
  const container = button.closest('.addon-products');
  if (!container) return;

  let error = container.querySelector('.cart-upsell__error');
  if (!error) {
    error = document.createElement('p');
    error.className = 'cart-upsell__error';
    error.setAttribute('role', 'alert');
    container.appendChild(error);
  }
  error.textContent = message;

  setTimeout(() => error?.remove(), ERROR_DISPLAY_DURATION);
}

/**
 * /cart/add.js only returns the added items, so read the cart total from the rendered section HTML.
 * @param {Record<string, string>} sections
 * @returns {number}
 */
function getCartItemCount(sections) {
  for (const html of Object.values(sections)) {
    if (!html) continue;
    const count = new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="cartItemCount"]')?.textContent;
    if (count) return parseInt(count, 10) || 0;
  }
  return 0;
}

/**
 * @param {HTMLButtonElement} button
 */
async function addUpsellToCart(button) {
  const variantId = Number(button.dataset.variantId);
  if (!variantId) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding...';

  const sectionIds = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
  });

  try {
    const response = await fetch(
      Theme.routes.cart_add_url,
      fetchConfig('json', {
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: Array.from(sectionIds).join(','),
        }),
      })
    );
    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }

    const sections = data.sections || {};

    document.dispatchEvent(
      new CartAddEvent({}, 'cart-upsell', {
        source: 'cart-upsell',
        variantId: String(variantId),
        sections,
        itemCount: getCartItemCount(sections),
      })
    );

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && 'showDialog' in cartDrawer && typeof cartDrawer.showDialog === 'function') {
      cartDrawer.showDialog();
    }
  } catch (error) {
    console.error('Cart upsell: failed to add product', error);
    if (button.isConnected) {
      button.disabled = false;
      button.textContent = originalText;
      showError(button, error instanceof Error ? error.message : 'Add to cart failed');
    }
  }
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest('.cart-upsell .checkbox-product');
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  event.preventDefault();
  addUpsellToCart(button);
});
